var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('banner-simulator',{attrs:{"country-code":_vm.userData.countryCode,"latitude":_vm.userData.lat,"longitude":_vm.userData.lon}}),_vm._v(" "),_c('section-slider'),_vm._v(" "),_c('company-data'),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e86e29c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page-simulator.vue
// module id = 906
// module chunks = 1